<template>
  <v-row>
    <v-col sm="1" lg="2" class="hidden-xs-only">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" sm="10" lg="8">
      <DetailCard title="Detalles Acompañante" :loading="cardLoading">
        <v-row justify="center">
          <v-col
            v-for="(item, index) in acompañante"
            :key="index"
            cols="12"
            sm="10"
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != null">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">No registrado</p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>
<script>
import DetailCard from "../../../components/admin/DetailCard.vue";
export default {
  data: () => ({
    cardLoading: true,
  }),
  components: {
    DetailCard,
  },

  mounted() {
    this.$store.dispatch(
      "detallesAcompanante",
      this.$route.params.id_acompanante
    );
    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },

  computed: {
    acompañante() {
      const acompañante = this.$store.getters.obtenerAcompanante;
      const competencia = [
        {
          label: "Identificación",
          value: acompañante.identificacion,
        },

        {
          label: "Nombres",
          value: acompañante.nombres,
        },

        {
          label: "Apellidos",
          value: acompañante.apellidos,
        },

        {
          label: "Telefono Movil",
          value: acompañante.telefono_movil,
        },

        {
          label: "Correo Electrónico",
          value: acompañante.correo,
        },

        {
          label: "Dirección",
          value: acompañante.direccion,
        },

        {
          label: "Regional",
          value: acompañante.regional,
        },

        {
          label: "Centro de Formación",
          value: acompañante.centro_formacion,
        },
        {
          label: "Cargo",
          value: acompañante.cargo,
        },
        {
          label: "Talla de Camiseta",
          value: acompañante.talla_camiseta,
        },
      ];

      return competencia;
    },
  },

  methods: {
    regresar() {
      this.$router.go(-1)
    }
  },
};
</script>
